import * as React from "react";
import { FormField, FileUpload } from "@amzn/awsui-components-react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";

export const FileUploadTab: React.FC<ContentEvaluationModel.FileUploadTabProps> = ({
    selectedFile,
    onFileChange,
    onFlashbarUpdated
}) => {
    const handleFileChange = ({ detail }: { detail: { value: File[] } }) => {
        if (detail.value.length > 0) {
            const file = detail.value[0];
            if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                onFileChange(file);
            } else {
                onFlashbarUpdated?.({
                    items: [{
                        type: "error",
                        content: "Only .docx files are supported",
                        dismissible: true,
                        onDismiss: () => onFlashbarUpdated?.(undefined)
                    }]
                });
                onFileChange(null);
            }
        } else {
            onFileChange(null);
        }
    };

    return (
        <FormField
            label="Upload Document"
            description="Upload a .docx file to evaluate"
        >
            <FileUpload
                onChange={handleFileChange}
                value={selectedFile ? [selectedFile] : []}
                i18nStrings={{
                    uploadButtonText: e =>
                        e ? "Choose different file" : "Choose file",
                    dropzoneText: e =>
                        e
                            ? "Drop file to replace"
                            : "Drop .docx file here or",
                    removeFileAriaLabel: e => `Remove ${e}`,
                    limitShowFewer: "Show fewer files",
                    limitShowMore: "Show more files",
                    errorIconAriaLabel: "Error"
                }}
                constraintText="Only .docx files are supported"
                accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                multiple={false}
            />
        </FormField>
    );
};
